import { Remarkable } from "remarkable";
import { linkify } from "remarkable/linkify";
import { memoize } from "lodash";

/**
 * Creates a new Remarkable markdown renderer instance with linkify plugin.
 *
 * Phase 4.6 Plan 01 Task 6 (SEC-008, REQ-28): explizit `html: false` als
 * Default — auch wenn Remarkable's eigener Default das ist, schützt ein
 * expliziter Eintrag gegen zukünftigen Refactor-Drift oder Library-
 * Updates, die den Default ändern könnten. Caller können den Schutz
 * bewusst über `{ html: true }` aufheben.
 *
 * @param options - Configuration options for Remarkable
 * @returns A new Remarkable instance
 */
export function getNewMarkdownRenderer(options = {}): Remarkable {
  return new Remarkable({ html: false, ...options }).use(linkify);
}

/**
 * Returns a memoized markdown renderer instance.
 * The same instance is returned on subsequent calls for better performance.
 *
 * @returns A memoized Remarkable instance
 */
export const getMarkdownRenderer = memoize(() => getNewMarkdownRenderer());
